import React from "react";
import styles from "./style.module.scss";
import FormContent from "../FormContent";
import { clearStorage } from "../../hooks/clearStorage";

export const Home = () => {

  const { clear } = clearStorage();
  clear();

  return (
    <>
      <div className={`${styles.container_card}`}>
        <FormContent />
      </div>
    </>
  );
};
